<template>
  <div class="empty-list_image">
    <strong>{{ message }}</strong>
    <img src="../assets/notfound.png" />
  </div>
</template>

<script>
export default {
  name: 'EmptyList',
  props: {
    message: {
      type: String,
      default: 'No Record Yet...',
    },
  },
}
</script>
